export const Apps = {
    Forms: 'integrated-form-app',
    LiveChat: 'integrated-livechat-app',
};
